import React from 'react';
const stats = [{
  value: '10',
  label: 'Volumi Completi'
}, {
  value: '480+',
  label: 'Pagine di Contenuti'
}, {
  value: '60',
  label: 'Unità Didattiche Pronte'
}, {
  value: '100%',
  label: 'Pronto da Stampare e Usare'
}];
export function StatsBar() {
  return <section aria-label="Numeri chiave" className="w-full border-y border-navy/10 bg-white px-5 py-8" data-id="element-165" data-mp="1od887h67frwn">
      <dl className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 text-center lg:grid-cols-4" data-id="element-166" data-mp="1ed7j1elnmhkj">
        {stats.map((stat, index) => <div key={stat.label} className={index > 0 ? 'lg:border-l lg:border-navy/10' : undefined} data-id="element-167" data-mp="19m8yu3xjozc0" data-mpi={index}>
            <dt className="sr-only" data-id="element-168" data-mp="15l5kxmz25ddf">{stat.label}</dt>
            <dd data-id="element-169" data-mp="10mcgsl5nuypx">
              <span className="block font-display text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-170" data-mp="10mvt9mcjkuwk">
                {stat.value}
              </span>
              <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.18em] text-ink-soft sm:text-xs" data-id="element-171" data-mp="vokfx1n1g29l">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}